<template>
  <div class="agreement-content">
    <div>欢迎您成为大金服务用户！</div>
    <div>一、 用户协议的确认</div>
    <div>本用户协议由您（"用户"）与大金服务（"微信小程序"）运营方大金空调技术（中国）有限公司（以下可简称为 "大金公司"）订立。在您申请注册成为大金服务微信小程序用户前，请您仔细阅读本用户协议。当您点击“我已阅读并同意”（包括《大金服务用户协议》及《大金服务小程序个人信息保护政策》）并完成用户注册程序后，即表示您自愿完全接受本用户协议，正式成为大金服务微信小程序用户。若您不同意本用户协议，或对本用户协议的条款存在任何疑问，请停止进行大金服务微信小程序用户注册程序，不要使用大金服务用户服务。</div>
    <div>二、 服务简介</div>
    <div>1、大金服务微信小程序后端备案域名为 daikinfw.daikin.net.cn；大金公司通过大金服务为您提供服务，您可以在大金服务微信小程序上预约维修、移机、保养清洗、视频工程师预约服务（以下可简称为"用户服务"）等；为改善用户体验或经营需要，用户服务的项目和内容可能会不时调整。</div>
    <div>2、用户服务的条件和规则包含于本用户协议以及大金公司在大金服务微信小程序内统一发布的服务条款、说明、通知公告、操作规则、温馨提示等规则（合称"微信小程序规则"）中；请您在使用本微信小程序前仔细阅读微信小程序规则，再享受用户服务，否则由此带来的不便和责任由您自行承担。</div>
    <div>3、您应自行准备如下设备并承担如下开支：</div>
    <div>(1) 上网设备：包括但不限于手机、计算机或其他必备的上网装置；</div>
    <div>(2) 上网开支：包括但不限于网络接入费、手机流量费等费用。</div>
    <div>4、为更好的为您提供用户服务，大金公司可能会委托相关合作方向您提供一部分用户服务而无须经过您的同意或特别告知您；对此，你完全理解并予以同意。</div>
    <div>三、用户管理</div>
    <div>1、大金公司在本微信小程序上仅向依法能够且有权订立具有法律约束力合同的自然人提供服务。因此，您应是具备完全民事权利能力和民事行为能力的自然人，若您不具备该条件，大金公司有权拒绝向您提供用户服务；若因此给大金公司或第三方造成损失的，您应承担全部赔偿责任。</div>
    <div>2、您申请成为大金服务微信小程序用户时，应自行向大金公司提供真实、准确、完整、合法有效的注册资料，并且当您的注册资料发生变动时，应及时进行更新。若您提供的注册资料信息错误、不实、过时或不完整，而因此而产生任何损失，我方不承担相应责任。</div>
    <div>3、您成功注册成为大金服务微信小程序用户后，您即可使用您注册的账户浏览、预约、咨询大金服务微信小程序。若您发现任何非法使用用户名或存在安全漏洞的情况，应立即通知我方。因您的保管疏忽、黑客行为、不可抗力或其他非我方原因导致您的账号遭他人非法使用或泄漏您的个人信息，我方不因此承担任何责任。</div>
    <div>4、除非有法律规定或依生效司法裁决，或取得大金许可，否则您的账户不得以任何方式转让、赠与或继承。 您在使用本微信小程序过程中实施的包括但不限于上传、发布各类图文、信息等行为时，应具有相应的权利能力与行为能力，且必须遵守如下规定，并承诺对自己的行为负全部责任：</div>
    <div>* 遵守中国的法律、法规、有关国际公约以及本协议及其他与本微信小程序相关的规定或条款；</div>
    <div>* 遵循与国际互联网有关的网络协议、规定、程序和惯例；禁止向本微信小程序上传带有病毒的、木马的和其他有害的图片、文件、照片、肖像等；不得通过本微信小程序进行任何可能妨碍互联网运行的活动。</div>
    <div>* 不得利用本微信小程序上传、展示或传播任何虚假的、骚扰性的、中伤他人的、辱骂性的或其他任何非法的信息资料；</div>
    <div>* 不得侵犯任何第三方或我方的合法权益（包括但不限于肖像权、名誉权、著作权、专利权、商标权、或其他法律所规定的权利），也不得干扰本微信小程序的正常运转；</div>
    <div>* 不得为任何非法目的而使用本微信小程序所提供服务；</div>
    <div>* 禁止基于商业目的模仿我方的产品和服务，包括但不限于复制和模仿我方的设计理念、图案、界面、图表、文档资料、商标、FLASH、音像、动画、美术等；</div>
    <div>* 禁止在未获得我方明确的书面许可的情况下，以任何方式全部或部分转载、引用、连接、抓取或以其他方式使用本微信小程序的信息内容；</div>
    <div>* 禁止未经我方许可，基于本微信小程序所提供的服务或其内容进行修改或制造派生其他产品；</div>
    <div>* 不得实施其他有悖于公序良俗的行为。</div>
    <div>我方有权无需您的同意，删除各类不符合法律政策、不真实及违反本协议的信息内容。</div>
    <div>四、 服务说明</div>
    <div>1、大金服务微信小程序上的服务信息随时有可能发生变动，大金公司对此不作特别通知。大金公司将尽合理的商业努力，使微信小程序内展示的服务信息尽可能准确、详细，但网页显示的信息仍可能会有一定的滞后性或差错，对此情形您充分知悉并予以理解。如您发现服务信息错误的或有疑问的，请您在第一时间告诉大金公司，并不要提交预约。</div>
    <div>2、本小程序只提供针对用户服务的预约，如有服务费用产生，请线下另行支付。</div>
    <div>五、 用户服务成立及履约基本规则</div>
    <div>1、当您预约时，请您仔细确认预约的产品分类、服务地址、期望联系电话、期望服务日期等信息。当现场联系人与您本人不一致的，现场联系人的行为和意思表示视为您的行为和意思表示，您应对现场联系人的行为及意思表示的法律后果承担连带责任。如果因为您填写的期望人联系电话、服务地址等信息错误，导致大金公司为您填写的现场联系人提供了服务，由此造成的损失由您自行承担。</div>
    <div>2、大金公司将会根据用户提供的服务信息进行预约受理，并安排工程师与客户电话联系及上门服务。 请您准确地填写自己的真实姓名、服务地址及联系方式。因如下情况造成预约延迟等，大金公司不会承担迟延服务的责任，并保留单方取消服务单的权利 ：</div>
    <div>(1) 您提供的服务地址、联系方式等信息错误或不够详细；</div>
    <div>(2) 情势变更因素；</div>
    <div>(3) 不可抗力，例如：自然灾害、交通戒严、罢工、骚乱、政府行为、突发战争等。</div>
    <div>3、大金公司将会根据用户在线上约定的时间提供在线视频指导服务。请您在有效的时间内与大金工程师进行连线，超过约定时间请重新进行预约。</div>
    <div>六、 所有权及知识产权条款</div>
    <div>1、大金公司作为大金服务微信小程序的运营商，拥有大金服务微信小程序内容及资源的著作权等合法权利，受国家法律保护。</div>
    <div>2、未经大金公司书面许可,任何单位或个人不得以任何方式非法地全部或部分复制、转载、引用、链接、抓取或以其他方式使用本站的信息内容，否则，大金公司有权追究其法律责任。</div>
    <div>3、大金服务微信小程序所刊登的资料信息(诸如文字、图表、标识、按钮图标、图像、声音文件片段、数字下载、数据编辑和软件)，均是大金公司或其内容提供者的财产，受中国和国际著作权法的保护。大金服务微信小程序上所有内容的汇编是大金公司的排他财产，受中国和国际版权法律的保护。大金服务微信小程序上所有软件都是大金公司或其关联公司或其软件供应商的财产，受中国和国际版权法律的保护。</div>
    <div>七、 条款更新及联系方式</div>
    <div>我们有权在必要时（包括但不限于为了适应互联网的发展改善本微信小程序及遵守最新的法律法规），无需提前进行公告而修改本协议。若本协议一旦发生变动，我们将会在相关页面上公布修改后的条款，您需同意该条款后才可继续使用本微信小程序。如果您不同意所改动的内容，您可以主动停止使用本微信小程序。如果您对于本协议或在使用微信小程序服务时对于您的个人信息或隐私情况有任何问题，请联系本微信小程序的线上客服作充分描述，我们将尽力解决。</div>
    <div>八、 结束服务</div>
    <div>1、大金公司可随时根据战略规划或市场行情中断一项或多项服务，除法律另有规定外，大金公司无义务对任何个人或第三方负责。您若反对任何用户协议条款或对后来的用户协议条款修改有异议，您可以行使如下权利：</div>
    <div>（1）不再使用大金公司用户服务；</div>
    <div>（2）通知大金公司停止对您提供服务。用户服务终止后，您使用大金服务微信小程序服务的权利马上终止。</div>
    <div>2、出现以下情况时，大金公司有权直接以注销用户账户的方式终止本用户协议，并有权永久冻结或注销您的账户在大金服务微信小程序权限：</div>
    <div>（1）您提供的手机等联系方式无法接收信息或实际不存在，且没有其他方式可以与您进行联系的；</div>
    <div>（2）您提供的用户信息中的内容不真实或不准确或不完整的；</div>
    <div>（3）用户协议及微信小程序规则变更时，您明示并通知大金公司不愿接受该等变更的；</div>
    <div>（4）因其他原因，大金公司决定终止为您提供用户服务的。</div>
    <div>3、您应当依照本协议的指引使用本微信小程序，如果由于您的疏忽或者恶意使用，给第三人或者我方合法权益造成损害的，您需要对由此而产生的一切法律后果承担全部的责任。</div>
    <div>九、 通知送达</div>
    <div>1、本协议项下大金公司对于用户所有的通知均可通过页面公告、系统通知、手机短信等方式进行，该等通知于发送之日视为已送达用户。</div>
    <div>2、用户对于大金公司的通知应通过大金公司官方对外正式公布的通信地址、电子邮件地址等联系地址进行送达。</div>
    <div>十、 适用法律及争议解决</div>
    <div>本用户协议适用中华人民共和国大陆地区适用之有效法律。如发生本用户协议或微信小程序规则与中华人民共和国法律相抵触，则这些内容将完全按法律规定重新解释，而其它条款则依旧保持对您的约束力。 若您和大金公司就本用户协议的订立和履行等事宜产生争议的，您和大金公司均一致同意将相关争议提交大金公司住所地有管辖权的人民法院管辖。</div>
  </div>
</template>

<style scoped lang="scss">
.agreement-content {
  font-size: 14px;
  color: #333333;
  line-height: 1.6;
}
</style>
